import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient, getValidToken } from "../apiClient"; // Added getValidToken
import toast from "react-hot-toast";
import Cookies from "js-cookie";

// 1. Fetch Problems
export const useGetProblems = () => {
  return useQuery({
    queryKey: ["problems"],
    queryFn: async () => {
      // Step 1: Securely get the REAL userid from your verification endpoint
      const { userid } = await getValidToken();
      
      // Step 2: Use that actual ID in the URL
      return apiClient(`/problems/getproblems/${userid}`);
    },
    select: (data) => data.totalproblem, 
    enabled: !!Cookies.get("accessToken"), // Only run if logged in
  });
};

// 2. Add/Edit Problem
export const useSaveProblem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (problemData) => {
      const isEdit = !!problemData._id;
      const endpoint = isEdit ? "/problems/editproblem" : "/problems/addproblem";
      const method = isEdit ? "PUT" : "POST";
      
      const payload = isEdit ? problemData : { problems: [problemData] };

      return apiClient(endpoint, {
        method,
        body: JSON.stringify(payload),
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["problems"] });
      toast.success("Problem saved successfully!");
    },
    onError: (error) => toast.error(error.message),
  });
};

// 3. Delete Problem
export const useDeleteProblem = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (problemIds) => 
      apiClient("/problems/deleteproblem", {
        method: "DELETE",
        body: JSON.stringify({ problems: problemIds }),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["problems"] });
      toast.success("Deleted successfully");
    },
    onError: (error) => toast.error(error.message),
  });
};